<template>
  <!--begin::Timeline vertical (desktop)-->
  <aside class="step-timeline step-timeline--desktop d-none d-lg-flex">
    <img
        v-if="showLogo"
        src="~/assets/images/logo/LOGO_ASUFIN_PINK.png"
        alt="ASUFIN"
        class="step-timeline-logo"
    />
    <div
        v-for="(step, index) in steps"
        :key="step.number"
        class="step-timeline-step"
        :class="{ 'is-active': step.number === currentStep, 'is-done': step.number < currentStep }"
    >
      <span class="step-timeline-marker">
        <span class="step-timeline-dot"></span>
        <span v-if="index < steps.length - 1" class="step-timeline-line"></span>
      </span>
      <span class="step-timeline-label">{{ step.label }}</span>
    </div>
  </aside>
  <!--end::Timeline vertical (desktop)-->

  <!--begin::Timeline horizontal (mobile)-->
  <aside class="step-timeline step-timeline--mobile d-flex d-lg-none">
    <template v-for="(step, index) in mobileSteps" :key="step.number">
      <span
          v-if="index > 0"
          class="step-timeline-mobile-line"
          :class="{ 'is-done': step.number <= currentStep }"
      ></span>
      <div
          class="step-timeline-mobile-step"
          :class="{ 'is-active': step.number === currentStep, 'is-done': step.number < currentStep }"
      >
        <span class="step-timeline-dot"></span>
        <span class="step-timeline-mobile-label">{{ step.label }}</span>
      </div>
    </template>
  </aside>
  <!--end::Timeline horizontal (mobile)-->
</template>

<script lang="ts">
import {computed, defineComponent} from 'vue';

export default defineComponent({
  name: 'StepTimeline',
  props: {
    steps: {
      type: Array as () => { number: number; label: string }[],
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    // Muestra el logo de ASUFIN encima de los pasos (solo en el timeline vertical de desktop).
    showLogo: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const mobileSteps = computed(() => props.steps.filter((step) => (
        step.number >= props.currentStep - 1 && step.number <= props.currentStep + 1
    )));

    return {
      mobileSteps,
    };
  },
});
</script>

<style scoped>
/* Desktop: vertical */
.step-timeline--desktop {
  flex-direction: column;
  flex: 0 0 220px;
  padding: 40px 24px;
  border-right: 1px solid #eef0f4;
}

.step-timeline-logo {
  display: block;
  max-width: 100%;
  height: auto;
  margin-bottom: 40px;
}

.step-timeline-step {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  color: #99a1b7;
  font-weight: 500;
}

.step-timeline-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.step-timeline-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #d7d9e2;
  background-color: #fff;
  flex-shrink: 0;
  box-sizing: border-box;
}

.step-timeline-line {
  width: 2px;
  flex: 1 1 auto;
  min-height: 36px;
  background-color: #e4e6ef;
  margin: 2px 0;
}

.step-timeline-label {
  padding-top: 1px;
}

.step-timeline-step.is-active .step-timeline-dot {
  border-color: #eb2b8e;
  box-shadow: 0 0 0 3px rgba(235, 43, 142, 0.15);
}

.step-timeline-step.is-active .step-timeline-label {
  color: #eb2b8e;
  font-weight: 700;
}

.step-timeline-step.is-done .step-timeline-dot {
  border-color: #eb2b8e;
  background-color: #eb2b8e;
}

.step-timeline-step.is-done .step-timeline-line {
  background-color: #eb2b8e;
}

/* Mobile: horizontal, compact (prev / current / next only) */
.step-timeline--mobile {
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 16px 12px;
  border-bottom: 1px solid #eef0f4;
}

.step-timeline-mobile-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: #99a1b7;
  font-weight: 500;
  min-width: 64px;
}

.step-timeline-mobile-label {
  font-size: 0.7rem;
  text-align: center;
  line-height: 1.1;
}

.step-timeline-mobile-line {
  flex: 0 1 32px;
  height: 2px;
  background-color: #e4e6ef;
  margin-top: -18px;
}

.step-timeline-mobile-line.is-done {
  background-color: #eb2b8e;
}

.step-timeline-mobile-step.is-active .step-timeline-dot {
  border-color: #eb2b8e;
  box-shadow: 0 0 0 3px rgba(235, 43, 142, 0.15);
}

.step-timeline-mobile-step.is-active .step-timeline-mobile-label {
  color: #eb2b8e;
  font-weight: 700;
}

.step-timeline-mobile-step.is-done .step-timeline-dot {
  border-color: #eb2b8e;
  background-color: #eb2b8e;
}
</style>
